export type Layer =
  | "content"
  | "taskBar"
  | "navigation"
  | "portal"
  | "targetPositioner"
  | "popup"
  | "tooltip"
  | "mapCluster"
  | "mapPOI"
  | "mapMainMarker"
  | "mapControls";

export const zIndexes: Record<Layer, number> = {
  content: 100,
  taskBar: 200,
  navigation: 800,

  portal: 900,
  targetPositioner: 1000,
  popup: 1010,
  tooltip: 1020,
  mapCluster: 10,
  mapPOI: 11,
  mapMainMarker: 12,
  mapControls: 13,
};
